export default __webpack_public_path__ + "static/devices-4dc827dbd93152a828fd75c427d2319d.png";